export default "__VITE_ASSET__B_Ike0lT__"